import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'New {{method}} order!',
        scheduled: 'Scheduled {{method}} order!',
      },
      labels: {
        today: 'today',
        time_remaining_to_accept: 'remaining to accept',
      },
      time_tag: {
        asap: '🕓 Pickup in {{time}}',
        scheduled: '🕓 Pickup {{day}} at {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Rough pickup estimate: {{time}}',
        scheduled: '🕓 Rough pickup estimate: {{day}} at {{time}}',
      },
      buttons: {
        confirm_order: 'Confirm order',
        cancel_order: 'Cancel order',
      },
      feedback: {
        rough_estimate_warning:
          "This is a rough estimate only. You'll receive the actual prep time once a driver is assigned and the delivery time confirmed. At that point, your ticket will be printed automatically.",
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Preparation time',
      labels: {
        today: 'Heute',
        order_time: {
          delivery: {
            asap: 'Delivery in',
            scheduled: 'Delivery on',
          },
          other: {
            asap: 'Pickup in',
            scheduled: 'Pickup on',
          },
        },
        can_you_make_it: 'Can you make it?',
        we_also_send_this_update_to_the_customer: 'We also send this update to the customer',
      },
      buttons: {
        yes_lets_go: 'Yes, let’s go!',
        no_change_time: 'No, change time',
        confirm: 'Confirm',
      },
      toasts: {
        order_confirmed: {
          title: 'Order #{{number}} confirmed',
          body: "Don't prepare yet! We'll notify you when a driver is assigned.",
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Unfortunately, the delivery needs to be canceled because the driver is not available. Click on the three dots at the top right to cancel the order and refund the money to the customer',
        [BackendErrorCode.DeliveryProviderException]:
          'Unfortunately, the delivery needs to be canceled because the driver is not available. Click on the three dots at the top right to cancel the order and refund the money to the customer',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Order accepted, but no driver is booked yet. We keep trying for 15 minutes and will tell you if none is found.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Something went wrong, please try again',
  },
};
